import * as React from "react";
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Card
} from "@material-ui/core";
import ArrowUp from "@material-ui/icons/ArrowUpward";
import ArrowDown from "@material-ui/icons/ArrowDownward";

interface Props {
  by: string;
  direction: string;
  onChange: (by, direction) => void;
}
interface State {}
export default class Sort extends React.Component<Props, State> {
  onChangeBy = (e, v) => {
    this.props.onChange(v, this.props.direction);
  };
  onChangeDirection = (e, v) => {
    this.props.onChange(this.props.by, v);
  };
  render() {
    return (
      <Card style={{ marginTop: 24, padding: 24 }}>
        <Typography>Sort By</Typography>
        <RadioGroup
          aria-label="Gender"
          name="gender1"
          row
          value={this.props.by}
          onChange={this.onChangeBy}
        >
          <FormControlLabel
            value="date"
            control={<Radio color="primary" />}
            label="Date Created"
          />
          <FormControlLabel
            value="reportCount"
            control={<Radio color="primary" />}
            label="Report Count"
          />
        </RadioGroup>
        <Divider />
        <Typography style={{ marginTop: 16 }}>Direction</Typography>
        <RadioGroup
          row
          value={this.props.direction}
          onChange={this.onChangeDirection}
        >
          <FormControlLabel
            value="asc"
            control={<Radio color="primary" />}
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                Ascending
                <ArrowUp />
              </div>
            }
          />
          <FormControlLabel
            value="desc"
            control={<Radio color="primary" />}
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                Descending
                <ArrowDown />
              </div>
            }
          />
        </RadioGroup>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/cases/components/sort.tsx